// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cropped-image {
  max-width: 100%;
}

.cropper {
  margin-bottom: 10px;
}

#filePicker {
  display: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImltYWdlLXVwbG9hZC1tb2RhbC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGVBQUE7QUFDSjs7QUFDQTtFQUNFLG1CQUFBO0FBRUY7O0FBQ0E7RUFDSSxhQUFBO0FBRUoiLCJmaWxlIjoiaW1hZ2UtdXBsb2FkLW1vZGFsLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNyb3BwZWQtaW1hZ2Uge1xuICAgIG1heC13aWR0aDogMTAwJVxufVxuLmNyb3BwZXIge1xuICBtYXJnaW4tYm90dG9tOiAxMHB4O1xufVxuXG4jZmlsZVBpY2tlciB7XG4gICAgZGlzcGxheTpub25lO1xufVxuXG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/image-upload-modal/image-upload-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACE,mBAAA;AAEF;;AACA;EACI,aAAA;AAEJ;AACA,ofAAof","sourcesContent":[".cropped-image {\n    max-width: 100%\n}\n.cropper {\n  margin-bottom: 10px;\n}\n\n#filePicker {\n    display:none;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
